import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class OpAmplifierAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normGBW = 30;
		this.normSR = 35;
		this.normVos = 5;
		this.normEn = 100;
		this.normIq = 2;

		this.rankGBW = 0;
		this.rankSR = 0;
		this.rankVos = 0;
		this.rankEn = 0;
		this.rankIq = 0;

		this.weightGBW = 0.25;
		this.weightSR = 0.15;
		this.weightVos = 0.05;
		this.weightEn = 0.03;
		this.weightIq = 0.02;

		this.rGBW = 0;
		this.rSR = 0;
		this.rVos = 0;
		this.rEn = 0;
		this.rIq = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_rGBW,rGBW,rankGBW,' +
					'part_rSR,rSR,rankSR,' +
					'part_rVos,rVos,rankVos,' +
					'part_rEn,rEn,rankEn,' +
					'part_rIq,rIq,rankIq,feRank,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Gain-Bandwitdh Product  GBW Typ (MHz)---------------------------------------------

		[this.rankGBW, this.rGBW] = this.calculateRankSingleSliderGTE(CIDS.GAIN_BANDWIDTH, product, this.normGBW);

		// ---------------------------------------------Slew Rate  SR Typ (V/µs)---------------------------------------------

		[this.rankSR, this.rSR] = this.calculateRankSingleSliderGTE(CIDS.SLEW_RATE, product, this.normSR);

		// ---------------------------------------------Input Offset Voltage  VOS Max (mV)---------------------------------------------

		[this.rankVos, this.rVos] = this.calculateRankSingleSliderLTE(CIDS.INPUT_OFFSET_VOLTAGE, product, this.normVos);

		// ---------------------------------------------Input Referred Voltage Noise Density  eN (nV/√Hz)---------------------------------------------

		[this.rankEn, this.rEn] = this.calculateRankSingleSliderLTE(
			CIDS.INPUT_REFERRED_VOLTAGE_NOISE_DENSITY,
			product,
			this.normEn
		);

		// ---------------------------------------------Quiescent Current  Iq Typ (mA)---------------------------------------------

		[this.rankIq, this.rIq] = this.calculateRankSingleSliderLTE(CIDS.QUIESCENT_CURRENT, product, this.normIq);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightGBW * this.rankGBW +
			this.weightSR * this.rankSR +
			this.weightVos * this.rankVos +
			this.weightEn * this.rankEn +
			this.weightIq * this.rankIq;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightGBW - this.weightSR - this.weightVos - this.weightEn - this.weightIq) * super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
